import styled, { keyframes } from 'styled-components';
import { tokens } from 'styles/tokens';

type IconActionProps = {
	hasAction?: boolean;
};

type Emptytext = {
	width: string;
};

const shine = keyframes`
 to {
		background-position-x: -200%;
	}
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;

	justify-content: center;
	align-items: center;

	width: 100%;
	height: 100%;
`;

export const PreviewContainer = styled.div`
	width: 100%;
	height: 75%;
	flex-grow: 2;

	position: relative;
`;

export const Image = styled.div<{ image: string }>`
	height: 100%;
	width: 100%;
	background-position: top;
	background-size: cover;
	background-image: url(${({ image }) => image});
	border-radius: 6px 6px 0 0;
`;

export const ImageLabelContainer = styled.div`
	position: absolute;
	top: 20px;
	right: 20px;

	background-color: ${tokens.color_gray_dark};

	padding: 3px 8px;

	font-weight: 600;
	font-size: 12px;
	line-height: 16px;
	color: ${tokens.color_white};

	opacity: 0.8;
	border-radius: 6px;
`;

export const MessageBody = styled.div`
	max-width: 300px;

	margin: 15px;

	display: -webkit-box;
	-webkit-line-clamp: 9;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const ActionContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	align-content: center;

	width: 100%;

	background-color: ${tokens.color_primary_lightest_select};
`;

export const TitleContainer = styled.div`
	display: flex;
	flex-direction: column;

	height: 100px;
`;

export const Title = styled.div`
	font-weight: 600;
	font-size: 16px;
	line-height: 22px;

	padding: 10px 20px 0 20px;

	color: ${tokens.color_gray_dark};

	display: -webkit-box;
	max-width: 200px;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;

	min-height: 55px;
`;

export const SubTitle = styled.div`
	font-weight: 500;
	font-size: 14px;
	line-height: 22px;

	padding: 12px 20px 5px 20px;

	color: ${tokens.color_gray_dark};
`;

export const IconContainer = styled.div<IconActionProps>`
	padding-right: 20px;
	cursor: ${({ hasAction }) => (hasAction ? 'pointer' : 'default')};
`;

export const EmptyText = styled.div<Emptytext>`
	height: 22px;
	margin: 15px 20px 10px 20px;
	width: ${({ width }) => width};
	opacity: 0.5;
	border-radius: 6px;

	background: #d8dee6;
	background: linear-gradient(110deg, #d8dee6 8%, #e6e6e6 18%, #d8dee6 33%);
	animation: 1.5s ${shine} linear infinite;
	background-size: 200% 100%;
`;

export const EmptyIcon = styled.div`
	margin-right: 15px;
	width: 35px;
	height: 35px;
	border-radius: 6px;
	background-color: ${tokens.color_cielo};
`;

export const ObjectContainer = styled.div`
	height: 100%;
`;

export const PdfObject = styled.object`
	width: 100%;
	height: 100%;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
`;

export const PreventScrollObject = styled.div`
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
`;

export const DefaultImage = styled.img`
	display: block;
	margin-left: auto;
	margin-right: auto;
	position: relative;
	width: 100%;
	height: 196px;
	object-fit: contain;
`;
